export default "__VITE_ASSET__22300f82__"